import styled from "styled-components"

export const DeprecatedErrorBlock = styled.div<{ $margin?: string | undefined }>`
  border-radius: 0.5rem;
  padding: 1rem;
  margin: ${({ $margin }) => $margin || "1.5rem 0"};
  border: 1px solid ${({ theme }) => theme.colors.danger.$300};
  background-color: ${({ theme }) => theme.colors.danger.$100};
  color: ${({ theme }) => theme.colors.danger.$200};
  line-height: normal;
`
